import { lazy } from "react";
import { Route } from "react-router-dom";

import { MessengerLayout } from "./components/messenger-layout";
import { PinLockScreen } from "./components/pin-lock-screen";
import { useCallBackgroundService } from "./components/use-call-background-service";
import { useCallWakeLock } from "./components/use-call-wake-lock";

const MessengerHome = lazy(() => import("./pages/messenger-home"));
const ConversationPage = lazy(() => import("./pages/conversation-page"));

/**
 * Wraps messenger routes with:
 * 1. PIN lock screen overlay
 * 2. Background service registration for PersistentBar (mini call widget)
 *
 * HuddleProvider lives at ShellLayout so the CallOverlay (also at shell
 * level, for cross-app persistence) has access to Huddle01 hooks.
 */
export function MessengerWithPinLock() {
  return (
    <>
      <MessengerCallServices />
      <div className="relative h-full w-full">
        <MessengerLayout />
        <PinLockScreen />
      </div>
    </>
  );
}

/**
 * Hosts messenger-level side effects.
 * Separated into its own component to keep hooks rules clean.
 */
function MessengerCallServices() {
  useCallBackgroundService();
  useCallWakeLock();
  return null;
}

export default function MessengerRoutes() {
  return (
    <Route element={<MessengerWithPinLock />}>
      <Route index element={<MessengerHome />} />
      <Route path=":conversationId" element={<ConversationPage />} />
    </Route>
  );
}
